import { render, staticRenderFns } from "./RelatorioJustificativaNaoAtendimentoList.vue?vue&type=template&id=4b979600&scoped=true"
import script from "./RelatorioJustificativaNaoAtendimentoList.vue?vue&type=script&lang=js"
export * from "./RelatorioJustificativaNaoAtendimentoList.vue?vue&type=script&lang=js"
import style0 from "./RelatorioJustificativaNaoAtendimentoList.vue?vue&type=style&index=0&id=4b979600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b979600",
  null
  
)

export default component.exports